<template>
 
 <div :class="{ 'sticky-nav': isSticky }" class="header">


  <div class="header-content">
   
    <!-- <div class="flex flex-wrap mx-auto py-2"> -->
    <!-- <div class="mx-auto"> -->
      
        <Slide width="300">
          <ul class="flex-col slide-list">
            <li
              v-for="category in allCategories"
              :key="category.id"
              :class="category.parent_id == null ? 'border p-1' : null"
            >
              <router-link
                :to="{
                  name: 'products',
                  query: { category: category.slug },
                }"
                class="w-auto text-center content-center text-sm font-semibold uppercase hover:text-teal-400 text-gray-900 text-"
                v-if="category.parent_id == null"
                :class="category.name_de == 'Sale' ? 'text-red-600' : ''"
              >
                {{ category.name_de }}
               
              </router-link>
            </li>
            <li class="border p-1">
              <router-link
                :to="{
                  name: 'shops',
                }"
                class="text-sm font-semibold uppercase hover:text-teal-400 text-gray-900"
              >SHOPS</router-link>
            </li>
          </ul>
        </Slide>
        <div class="header-logo-wishlist">


          <div class="header-logo">
        <router-link to="/">
          <img class="h-6" src="@/assets/images/homeface-logo.png" alt="Site Logo" />
        </router-link>
      </div>

        <div class="header-wish-drop-cart">
        <wishlist></wishlist>
        <userdropdown></userdropdown>
        <shoppingcarddropdown></shoppingcarddropdown>
      </div>
    <!-- </div> -->
  <!-- </div> -->
</div>
  </div>


  <div class="header-search">
    <form class="flex w-full rounded p-2" @submit.prevent="searchProduct">
            <input
              type="search"
              class="outline-none text-sm font-semibold text-gray-800 w-full border border-gray-400 focus:border-teal-400 h-10"
              placeholder="Suche..."
              v-model="search"
              @keyup.enter="searchProduct"
            />
            <button type="submit">
              <img
                class="outline-none bg-teal-400 px-3 py-3 h-10"
                src="../../../assets/images/search.svg"
                alt="Search Icon"
              />
            </button>
          </form>
        </div>
 </div>
 

</template>


<script>
import wishlist from "./Wishlist";
import userdropdown from "./UserDropdown";
import shoppingcarddropdown from "./ShoppingCardDropdown";
import { Slide } from "vue-burger-menu"; // import the CSS transitions you wish to use, in this case we are using `Slide`
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    userdropdown,
    shoppingcarddropdown,
    wishlist,
    Slide, // Register your component
  },
  data() {
    return {
      slug: this.$route.params.slug,
      search: "",
      isSticky: false,
    };
  },
  watch:{
    $route (){
        document.querySelector('.bm-menu').style.width = "0px";
        document.body.classList.remove("overlay");
    }
  },
  mounted(){
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy(){
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapActions(["fetchCategories"]),

    searchProduct() {
      
      this.$router
        .push({ path: "/products", query: { q: this.search } })
        .catch(() => {});
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.isSticky = scrollTop > 65;
    },
  },
  computed: {
    ...mapGetters(["allCategories"]),
  },
  created() {
    this.fetchCategories();
  },
};
</script>




<style>

@media(min-width:340px) and (max-width: 600px){
  .sticky-nav .header-search{
  position: fixed;
  /* top: 0; */
  /* left: 0; */
  width: 100%;
  transform: translateY(-60%);
  /* transition: transform 1s; */
  z-index: 9999;
  background-color: white;
  width: 100% !important;

}

.sticky-nav .el-dropdown-menu{
  z-index: 999999 !important;
}

.sticky-nav .w-full{
  transition: all 1s;
  width: 80% !important;
  margin-left: 31px;
  z-index: 99999;

}

.sticky-nav .bm-burger-button {
  transition: all 1s;
  position: fixed;
  z-index: 99999;
  top: 17px !important;
  left: 20px !important;
}

.sticky-nav .bm-menu{
  z-index: 9999999;
}

.sticky-nav .sticky-nav-450-shopping{
  position: fixed;
  top: 40px;
  z-index: 99999;
  right: 18px;
  transform: translateY(-100%);
  transition: all 1s ease-in;
}

.sticky-nav.isSticky .sticky-nav-450-shopping {
  transform: translateY(0);
}

}



@media (min-width: 415px) and (max-width: 600px) {
  .app-500 {
    width: 494px;
  }
  .sticky-nav .header-search{
  position: fixed;
  /* top: 0; */
  /* left: 0; */
  width: 100%;
  transform: translateY(-60%);
  /* transition: transform 1s; */
  z-index: 9999;
  width: 100% !important;
  background-color: white;
}

.sticky-nav .w-full{
  transition: all 1s;
  width: 80% !important;
  margin-left: 31px;
  z-index: 99999;

}

.sticky-nav .bm-burger-button {
  transition: all 1s;
  position: fixed;
  z-index: 99999;
  top: 17px !important;
  left: 20px !important;
}

.sticky-nav .bm-menu{
  z-index: 9999999;
}

.sticky-nav .sticky-nav-450-shopping{
  position: fixed;
  top: 40px;
  z-index: 99999;
  right: 18px;
  transform: translateY(-100%);
  transition: all 1s;
}

.sticky-nav.isSticky .sticky-nav-450-shopping {
  transform: translateY(0);
}

/* .sticky-nav.isSticky {
  transform: translateY(0);
} */
}

@media(max-width: 600px){

  .header-logo-wishlist{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 30px;
  }

  .header-logo{
    margin-left:45px;
  }

  .header-search{
    height: 60px;
    width: 100% !important;
  }

  .header-wish-drop-cart{
    display: flex;
    flex-direction: row;
    gap: 10px;
    margin-right: 20px;
  }

  .header{
    height: 100px;
    display: flex;
    flex-direction: column;
  }
  .header-content{
   height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .bm-burger-button {
    top: 59px;
    
}
  /* .header-search{
    flex: 3;
  } */
}

@media(max-width: 390){
  .bm-menu{
    width:100% !important;
  }
}



.bm-overlay{
  background:rgb(255, 255, 255) !important;
  /* overflow: hidden !important;
  position: fixed !important;
  width: 100% !important;
  height: 100% !important;

  transition: all 1s; */
}
.bm-burger-button {
  top: 39px !important;
  left: 10px !important;
  width: 20px !important;
  height: 20px !important;
}

.bm-burger-bars {
  background-color: #474444;
}

.bm-menu {
  background-color: white !important;
  padding-top: 30px !important;
}

.bm-cross {
  background-color: #474444 !important;
}

.bm-item-list > * {
  padding: 0px;
}

.bm-item-list {
  margin-left: 0px !important;
 
}


@media(max-width:450px){
  .bm-item-list {
  padding: 5px !important;
  }
  .slide-list{
    padding: 10px !important;
  }
}
</style>
